/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.krone\":[\"Ympyrä, jonka sisällä kirjaimet KR\"]}");